<template>
    <svg
        width="32"
        height="18"
        viewBox="0 0 32 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M5.77442 17.903C7.22471 17.903 8.4004 16.7617 8.4004 15.3538C8.4004 13.946 7.22471 12.8047 5.77442 12.8047C4.32413 12.8047 3.14844 13.946 3.14844 15.3538C3.14844 16.7617 4.32413 17.903 5.77442 17.903Z"
            fill="currentColor"
        />
        <path
            d="M12.458 17.6335C13.9083 17.6335 15.084 16.4922 15.084 15.0843C15.084 13.6765 13.9083 12.5352 12.458 12.5352C11.0077 12.5352 9.83203 13.6765 9.83203 15.0843C9.83203 16.4922 11.0077 17.6335 12.458 17.6335Z"
            fill="currentColor"
        />
        <path
            d="M21.165 17.903C22.6153 17.903 23.791 16.7617 23.791 15.3538C23.791 13.946 22.6153 12.8047 21.165 12.8047C19.7148 12.8047 18.5391 13.946 18.5391 15.3538C18.5391 16.7617 19.7148 17.903 21.165 17.903Z"
            fill="currentColor"
        />
        <path
            d="M27.3408 17.903C28.7911 17.903 29.9668 16.7617 29.9668 15.3538C29.9668 13.946 28.7911 12.8047 27.3408 12.8047C25.8905 12.8047 24.7148 13.946 24.7148 15.3538C24.7148 16.7617 25.8905 17.903 27.3408 17.903Z"
            fill="currentColor"
        />
        <path
            d="M19.2195 14.1339C11.8759 14.1339 3.74693 14.0713 2.49405 14.0613C2.03038 13.6142 1.62926 13.0909 1.625 12.9171V12.4893H17.9949H30.6387C30.6238 12.8846 30.6139 13.4663 30.662 13.8452C30.6733 13.934 30.6935 14.0133 30.72 14.0839C30.5906 14.0838 30.4438 14.0784 30.2885 14.0726C30.0985 14.0656 29.883 14.0576 29.6518 14.0576C29.581 14.0576 29.5087 14.0584 29.4347 14.0601C27.3185 14.109 23.8816 14.1339 19.2195 14.1339Z"
            fill="currentColor"
        />
        <path
            d="M2.04836 12.8903C2.1276 13.0546 2.38347 13.3703 2.66888 13.6613C4.36537 13.6746 12.1553 13.7325 19.2188 13.7325C23.8777 13.7325 27.3113 13.7077 29.424 13.6588C29.7198 13.652 29.9925 13.6602 30.2296 13.6688C30.2126 13.4259 30.21 13.1478 30.2136 12.8903H2.04836ZM1.21094 12.0879H31.0714C31.0714 12.0879 30.9982 13.219 31.0714 13.796C31.1446 14.3729 31.771 14.2295 31.3641 14.3958C30.9902 14.5485 30.4162 14.4586 29.6511 14.4586C29.5834 14.4586 29.5144 14.4593 29.4437 14.461C22.257 14.6272 2.32459 14.461 2.32458 14.461C2.32458 14.461 1.21094 13.4428 1.21094 12.9171C1.21094 12.3914 1.21094 12.0879 1.21094 12.0879Z"
            fill="currentColor"
        />
        <path
            d="M26.8047 6.47266L28.7609 9.83707L29.9352 11.8542"
            stroke="currentColor"
            stroke-linecap="round"
        />
        <path
            d="M24.1719 8.45703L26.7615 10.252L27.4087 10.7005L29.3511 12.0469"
            stroke="currentColor"
            stroke-linecap="round"
        />
        <path
            d="M6.98871 8.26172L5.90921 9.00953L3.75104 10.5084L1.80859 11.8515"
            stroke="currentColor"
            stroke-linecap="round"
        />
        <path
            d="M6.75689 5.23673L3.80876 9.26273L2.04275 11.6775"
            stroke="currentColor"
            stroke-linecap="round"
        />
        <path d="M12.503 0.90332H8.30078V1.92315H12.503V0.90332Z" fill="none" />
        <path
            d="M12.0905 1.30469H8.71484V1.52214H12.0905V1.30469Z"
            stroke="currentColor"
        />
        <path
            d="M23.0108 0.90332H18.8086V1.92315H23.0108V0.90332Z"
            fill="none"
        />
        <path
            d="M22.5983 1.30469H19.2227V1.52214H22.5983V1.30469Z"
            stroke="currentColor"
        />
        <path
            d="M8.15591 11.5586C7.59553 11.1057 5.89543 9.59944 5.31443 7.57322C4.73144 5.54001 5.23875 2.90971 5.43912 2.0332H12.9019H26.6742C27.0123 2.65943 28.0017 4.65712 28.0017 6.5866C28.0017 8.42573 26.4634 10.646 25.8523 11.4554L21.0471 7.8039L20.7904 7.60881L20.5352 7.80575L15.7664 11.4858L11.9895 7.83549L11.6486 7.50601L11.3644 7.88284C11.3576 7.89181 10.6789 8.7908 9.91328 9.70995C8.84903 10.9876 8.35707 11.4161 8.15591 11.5586Z"
            fill="currentColor"
        />
        <path
            d="M5.77344 2.43421C5.55699 3.4842 5.21024 5.71535 5.71206 7.46546C6.18996 9.13213 7.48235 10.4372 8.15799 11.0295C8.41962 10.7894 8.88415 10.3116 9.66346 9.37077C10.3922 8.49097 11.0241 7.65403 11.0304 7.64569L11.5987 6.89205L15.7967 10.9493L20.788 7.09764L25.7682 10.8821C26.5219 9.82082 27.5879 8.00771 27.5879 6.58642C27.5879 4.92582 26.8096 3.19533 26.4206 2.43421H5.77344ZM5.11181 1.63184H26.9194C26.9194 1.63184 28.4145 4.13021 28.4145 6.58642C28.4145 9.04264 25.9272 12.022 25.9272 12.022L20.7919 8.11962L15.7351 12.022L11.6974 8.11962C11.6974 8.11962 8.75503 12.022 8.09103 12.022C7.86971 12.022 7.79591 12.022 7.79591 12.022H8.09103C8.09103 12.022 5.66058 10.2782 4.91577 7.68062C4.17097 5.08309 5.11181 1.63184 5.11181 1.63184Z"
            fill="currentColor"
        />
    </svg>
</template>
